import React, { useEffect, useRef, useState } from 'react'
import { Modal } from "react-bootstrap";
import { TextField } from "@rmwc/textfield";
import { useDispatch, useSelector } from 'react-redux';
import * as actionCreator from "../../../../action/quote_order/order.action.js";
import * as validate from "../../validations";
import { Select } from "@rmwc/select";
import { Checkbox } from "@rmwc/checkbox";
import Questions from "../Questions.js";

import Cards from "../../../../assets/images/cards-pic.svg";
import NortonSecure from "../../../../assets/images/paymentcertified/norton.png";
import Authorise from "../../../../assets/images/paymentcertified/authorize.png";
import Macfee from "../../../../assets/images/paymentcertified/macfee.png";
import Ssl from "../../../../assets/images/paymentcertified/ssl.png";

import ThankYou from "../../ThankYou.js";
import CommonPromptBox from "../../CommonPromptBox.js";
import TermsAndCondition from "./TermsAndCondition.js";
import { const_var } from '../../../../redux/reducers/reducer.js';
import AnimButton from '../../../Button/AnimButton.js';
import CurrencyFormat from 'react-currency-format';

const CheckOut = () => {
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const state = useSelector((state) => state.orderReducer);
  const [showNext, setShowNext] = useState(false);
  const [showModal, setShowModal] = useState(false)

  const images = [NortonSecure, Authorise, Macfee, Ssl];
  const next_texts = [
    'You will be able to review & revise your order before it is finalized.',
    'Balance & sales tax due after installation is complete & you have inspected & accepted the structure.',
    'Once your order is placed, we will email you an order PDF file that has full details of your building and a paid invoice.'
  ]

  const hideModal = () => {
    dispatch(actionCreator.updateTempPostData("", true));
    dispatch(actionCreator.handleOrderModal("close"));
  }

  const handleCheckout = () => {
    if (formRef.current) {
      if(!state.showProcessLoader) {
        formRef.current.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }
  }

  useEffect(() => {
    if (state.paymentOption.type == 1) {
      //this.loadStripe();
    }
  }, [])

  useEffect(() => {
    setShowModal(state.isShowThankYou)
  }, [state.isShowThankYou, state.showProcessLoader])

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
        document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [])

  const nextRef = useRef(null);
  const handleOutsideClick = (event) => {
      if (nextRef.current && !nextRef.current.contains(event.target)) {
          setShowNext(false);
      }
  }


  const loadStripe = () => {
    let dynamicKey = state.paymentOption.key;
    if (!window.document.getElementById("stripe-script")) {
      var s = window.document.createElement("script");
      s.id = "stripe-script";
      s.type = "text/javascript";
      s.src = "https://js.stripe.com/v2/";
      s.onload = () => {
        window["Stripe"].setPublishableKey(dynamicKey);
      };
      window.document.body.appendChild(s);
    }
  };
  let savingPrice = 0
  if(state.order_data != undefined){
    savingPrice = parseFloat(state.order_data.down_payment_discount_total) + parseFloat(state.order_data.discount_amount)
  }
  return (
    <div>
      <Modal
        show={state.checkoutModal}
        keyboard={false}
        backdrop="static"
        onHide={(e) => hideModal()}
        dialogClassName={'revamp-checkout-modal react-modal modal-big modal-bg-check'}
        id="checkout-modal"
        backdropClassName="checkoutmodal-prefix-parent ract-modal-pre-parent modal-bg-check"
      >
        <Modal.Body>
          <div className={state.termsAndConditionDialogExtraClassToggle?'d-none': ''}>
            <div className='checkout-header'>
              <span>Order Information</span>
              <div className='close' onClick={() => hideModal()}>
                <i className='icon-cross-ico'></i>
              </div>
            </div>

            <div className={`checkout-container ${state.showProcessLoader ? 'form-submiting' : ''}`}>
              <div className='checkout-left-container'>
                <form
                  ref={formRef}
                  id="configuration"
                  name="configuration"
                  onSubmit={(e) => dispatch(actionCreator.onSubmitCheckout(e))}
                >
                  <div className='checkout-section'>
                    <div className='checkout-section-title'>Personal Information</div>

                    <div className='row checkout-section-content'>
                      <div className='col-md-6 form-group'>
                        <div className='form-label'>First Name</div>
                        <div className={state.displayerrorMessage.first_name ? 'floating-label-input invalid-input': 'floating-label-input'}>
                          <TextField
                            name="first_name"
                            value={state.TempData.first_name}
                            placeholder='e.g. Steve'
                            onChange={(e) =>
                              dispatch(actionCreator.onorderTextFiledChangeValue(
                                e,
                                "first_name",
                                "First Name"
                              ))
                            }
                            onBlur={(e) =>
                              dispatch(actionCreator.onorderTextFiledChangeValue(
                                e,
                                "first_name",
                                "First Name"
                              ))
                            }
                          />
                          <span className="error-icon icon-info-ico"></span>
                          <div className="errorMessage" id="fnameErrorMessage">
                            {state.displayerrorMessage.first_name}
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6 form-group'>
                        <div className='form-label'>Last Name</div>
                        <div className={state.displayerrorMessage.last_name ? 'floating-label-input invalid-input': 'floating-label-input'}>
                          <TextField
                            name="last_name"
                            value={state.TempData.last_name}
                            placeholder='e.g. McMahon'
                            onChange={(e) =>
                              dispatch(actionCreator.onorderTextFiledChangeValue(
                                e,
                                "last_name",
                                "Last Name"
                              ))
                            }
                            onBlur={(e) =>
                              dispatch(actionCreator.onorderTextFiledChangeValue(
                                e,
                                "last_name",
                                "Last Name"
                              ))
                            }
                          />
                          <span className="error-icon icon-info-ico"></span>
                          <div className="errorMessage" id="lnameErrorMessage">
                            {state.displayerrorMessage.last_name}
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6 form-group'>
                        <div className='form-label'>Email</div>
                        <div className={state.displayerrorMessage.email ? 'floating-label-input invalid-input': 'floating-label-input'}>
                          <TextField
                            name="email"
                            value={state.TempData.email}
                            placeholder='e.g. steve.mcmahon@gmail.com'
                            onChange={(e) =>
                              dispatch(actionCreator.onorderTextFiledChangeValue(
                                e,
                                "email",
                                "Email"
                              ))
                            }
                            onBlur={(e) =>
                              dispatch(actionCreator.onorderTextFiledChangeValue(
                                e,
                                "email",
                                "Email"
                              ))
                            }
                          />
                          <span className="error-icon icon-info-ico"></span>
                          <div className="errorMessage" id="emailErrorMessage">
                            {state.displayerrorMessage.email}
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6 form-group'>
                          <div className='form-label'>Phone Number</div>
                          <div className={state.displayerrorMessage.phone_no ? 'floating-label-input invalid-input': 'floating-label-input'}>
                            <TextField
                              name="phone_no"
                              value={state.TempData.phone_no}
                              placeholder='e.g. (555) 555-1234'
                              maxLength="10"
                              onKeyUp={(e) => validate.numericCheck(e)}
                              onChange={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "phone_no",
                                  "Number"
                                ))
                              }
                              onBlur={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "phone_no",
                                  "Number"
                                ))
                              }
                            />
                            <span className="error-icon icon-info-ico"></span>
                            <div className="errorMessage" id="numberErrorMessage">
                              {state.displayerrorMessage.phone_no}
                            </div>
                          </div>
                      </div>
                      {
                        const_var.isKLinkEnable == false && <div className='col-md-6 form-group'>
                          <div className='form-label'>Sensei Sales ID</div>
                          <div className={state.displayerrorMessage.sensei_sales_id ? 'floating-label-input invalid-input': 'floating-label-input'}>
                            <TextField
                              name="sensei_sales_id"
                              value={state.TempData.sensei_sales_id}
                              placeholder='e.g. ABC123'
                              maxLength="6"
                              onChange={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "sensei_sales_id",
                                  "Sensei Sales ID"
                                ))
                              }
                              onBlur={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "sensei_sales_id",
                                  "Sensei Sales ID"
                                ))
                              }
                            />
                            <span className="error-icon icon-info-ico"></span>
                            <div className="errorMessage" id="numberErrorMessage">
                              {state.displayerrorMessage.sensei_sales_id}
                            </div>
                          </div>
                      </div>
                      }
                    </div>
                  </div>

                  <div className='checkout-section'>
                    <div className='checkout-section-title'>Installation Address</div>

                    <div className='row checkout-section-content'>
                      <div className='col-md-6 form-group'>
                        <div className='form-label'>Address</div>
                        <div className={state.displayerrorMessage.shipping_address_line_1 ? 'floating-label-input invalid-input': 'floating-label-input'}>
                          <TextField
                            value={state.TempData.shipping_address_line_1}
                            name="shipping_address_line_1"
                            placeholder='e.g. 3139 Oakland, WI 53211, United States'
                            onChange={(e) =>
                              dispatch(actionCreator.onorderTextFiledChangeValue(
                                e,
                                "shipping_address_line_1",
                                "Address Line"
                              ))
                            }
                            onBlur={(e) =>
                              dispatch(actionCreator.onorderTextFiledChangeValue(
                                e,
                                "shipping_address_line_1",
                                "Address Line"
                              ))
                            }
                            maxLength={60}
                          />
                          <span className="error-icon icon-info-ico"></span>
                          <div className="errorMessage" id="addresslineErrorMessage">
                            { state.displayerrorMessage.shipping_address_line_1 }
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6 form-group'>
                        <div className='form-label'>City</div>
                        <div className={state.displayerrorMessage.shipping_city ? 'floating-label-input invalid-input': 'floating-label-input'}>
                          <TextField
                            name="shipping_city"
                            placeholder='e.g. Philadelphia'
                            onKeyUp={(e) => validate.alphabetCheck(e)}
                            onChange={(e) =>
                              dispatch(actionCreator.onorderTextFiledChangeValue(
                                e,
                                "shipping_city",
                                "City"
                              ))
                            }
                            onBlur={(e) =>
                              dispatch(actionCreator.onorderTextFiledChangeValue(
                                e,
                                "shipping_city",
                                "City"
                              ))
                            }
                          />
                          <span className="error-icon icon-info-ico"></span>
                          <div className="errorMessage" id="cityErrorMessage">
                            {state.displayerrorMessage.shipping_city}
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6 form-group custom-select-label-order'>
                        <div className='form-label'>State</div>
                        <div className={'floating-label-input floating-label-inside'}>
                          {state.bjD.length != undefined ? (
                            <Select
                              value={state.shippingState}
                              className="cpanelselect"
                              // placeholder='e.g. Pennsylvania'
                              ripple="RipplePropF"
                              name="shipping_state"
                              onChange={(e) =>
                                dispatch(actionCreator.shippingStateChange(e.target.value))
                              }
                              options={state.bjD.map((val, index) => {
                                return { value: val.name, label: val.name };
                              })}
                            />
                          ) : null}
                        </div>
                      </div>
                      <div className='col-md-6 form-group col-sm-6'>
                        <div className='form-label'>Zip Code</div>
                        <div className={state.displayerrorMessage.shipping_zipcode ? 'floating-label-input invalid-input': 'floating-label-input'}>
                          <TextField
                            name="shipping_zipcode"
                            maxLength="5"
                            placeholder='e.g. 19019'
                            value={state.TempData.shipping_zipcode}
                            onKeyUp={(e) => validate.numericCheckForZipCode(e)}
                            onChange={(e) =>
                              dispatch(actionCreator.onorderTextFiledChangeValue(
                                e,
                                "shipping_zipcode",
                                "Zip Code"
                              ))
                            }
                            onBlur={(e) =>
                              dispatch(actionCreator.onorderTextFiledChangeValue(
                                e,
                                "shipping_zipcode",
                                "Zip Code"
                              ))
                            }
                          />
                          <span className="error-icon icon-info-ico"></span>
                          <div className="errorMessage" id="zipcodeErrorMessage">
                            {state.displayerrorMessage.shipping_zipcode}
                          </div>
                        </div>
                      </div>
                      {
                        !state.addNewBillingAddress &&
                        <div className='col-md-12 new-billing-address' onClick={() => dispatch(actionCreator.billingAddressCheckboxChange("addBilling"))}><i className='icon-plus'></i>Add New Billing Address</div>
                      }
                    </div>
                  </div>

                  {
                    state.addNewBillingAddress &&
                    <div className='checkout-section'>
                      <div className='checkout-section-title'>
                        Billing Address
                        <span>
                          <Checkbox
                            className="secondary ml-sm-3 d-inline-flex"
                            ripple="RipplePropF"
                            label="Same as Installation Address"
                            checked={state.billingAddressCheckbox}
                            onChange={() => dispatch(actionCreator.billingAddressCheckboxChange())}
                          />
                        </span>
                      </div>

                      <div className='row checkout-section-content'>
                        <div className='col-md-6 form-group'>
                          <div className='form-label'>Address</div>
                          <div className={state.displayerrorMessage.billing_address_line_1 ? 'floating-label-input invalid-input': 'floating-label-input'}>
                            <TextField
                              value={state.TempData.billing_address_line_1}
                              name="billing_address_line_1"
                              placeholder='e.g. 3139 Oakland, WI 53211, United States'
                              onChange={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "billing_address_line_1",
                                  "Address Line"
                                ))
                              }
                              onBlur={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "billing_address_line_1",
                                  "Address Line"
                                ))
                              }
                              maxLength={60}
                            />
                            <span className="error-icon icon-info-ico"></span>
                            <div className="errorMessage" id="addresslineErrorMessage">
                              { state.displayerrorMessage.billing_address_line_1 }
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6 form-group'>
                          <div className='form-label'>City</div>
                          <div className={state.displayerrorMessage.billing_city ? 'floating-label-input invalid-input': 'floating-label-input'}>
                            <TextField
                              name="billing_city"
                              placeholder='e.g. Philadelphia'
                              onKeyUp={(e) => validate.alphabetCheck(e)}
                              onChange={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "billing_city",
                                  "City"
                                ))
                              }
                              onBlur={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "billing_city",
                                  "City"
                                ))
                              }
                            />
                            <span className="error-icon icon-info-ico"></span>
                            <div className="errorMessage" id="cityErrorMessage">
                              {state.displayerrorMessage.billing_city}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6 form-group custom-select-label-order'>
                          <div className='form-label'>State</div>
                          <div className={'floating-label-input floating-label-inside'}>
                            {state.bjD.length != undefined ? (
                              <Select
                                value={state.billingState}
                                // placeholder='e.g. Pennsylvania'
                                className="cpanelselect"
                                ripple="RipplePropF"
                                name="billing_state"
                                onChange={(e) =>
                                  dispatch(actionCreator.billingStateChange(e.target.value))
                                }
                                options={state.bjD.map((val, index) => {
                                  return { value: val.name, label: val.name };
                                })}
                              />
                            ) : null}
                          </div>
                        </div>
                        <div className='col-md-6 form-group col-sm-6'>
                          <div className='form-label'>Zip Code</div>
                          <div className={state.displayerrorMessage.billing_zipcode ? 'floating-label-input invalid-input': 'floating-label-input'}>
                            <TextField
                              name="billing_zipcode"
                              placeholder='e.g. 19019   '
                              maxLength="5"
                              value={state.TempData.billing_zipcode}
                              onKeyUp={(e) => validate.numericCheckForZipCode(e)}
                              onChange={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "billing_zipcode",
                                  "Zip Code"
                                ))
                              }
                              onBlur={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "billing_zipcode",
                                  "Zip Code"
                                ))
                              }
                            />
                            <span className="error-icon icon-info-ico"></span>
                            <div className="errorMessage" id="zipcodeErrorMessage">
                              {state.displayerrorMessage.billing_zipcode}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                  <div className='checkout-section'>
                    <div className='checkout-section-title'>Payment Details</div>
                    <div className='checkout-section-content'>
                      <div className='row card-image-container'>
                        <div className=' col-md-6 form-group'>
                          <div className='form-label'>Cardholder Name</div>
                          <div className={state.displayerrorMessage.cardholder ? 'floating-label-input invalid-input': 'floating-label-input'}>
                            <TextField
                              name="cardholder"
                              placeholder='e.g. Steve McMahon'
                              value={state.TempData.cardholder}
                              onChange={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "cardholder",
                                  "Cardholder Name"
                                ))
                              }
                              onBlur={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "cardholder",
                                  "Cardholder Name"
                                ))
                              }
                            />
                            <span className="error-icon icon-info-ico"></span>
                            <div className="errorMessage" id="cardholderErrorMessage">
                              {state.displayerrorMessage.cardholder}
                            </div>        
                          </div>
                        </div>
                        <div className='col-md-6 card-image'>
                          <img src={process.env.REACT_APP_BASE_URL+Cards} className="img-fluid" alt='cards img' />
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-md-6 form-group'>
                          <div className='form-label'>Card Number</div>
                          <div className={state.displayerrorMessage.cardnumber ? 'floating-label-input invalid-input': 'floating-label-input'}>
                            <TextField
                              name="cardnumber"
                              placeholder='e.g. Steve McMahon'
                              value={state.TempData.cardnumber}
                              onKeyUp={(e) => validate.numericCheck(e)}
                              maxLength="16"
                              onChange={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "cardnumber",
                                  "Card Number"
                                ))
                              }
                              onBlur={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "cardnumber",
                                  "Card Number"
                                ))
                              }
                            />
                            <span className="error-icon icon-info-ico"></span>
                            <div className="errorMessage" id="cardnumberErrorMessage">
                              {state.displayerrorMessage.cardnumber}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-md-3 form-group'>
                          <div className='form-label'>MM/YYYY</div>
                          <div className={state.displayerrorMessage.expirydate ? 'floating-label-input invalid-input': 'floating-label-input'}>
                            <TextField
                              id="expiryDate"
                              name="expirydate"
                              placeholder='e.g. 11/25'
                              maxLength="7"
                              onKeyUp={(e) => validate.expiryDateCheck(e)}
                              value={state.TempData.expirydate}
                              onChange={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "expirydate",
                                  "Expiry Date"
                                ))
                              }
                              onBlur={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "expirydate",
                                  "Expiry Date"
                                ))
                              }
                            />
                            <span className="error-icon icon-info-ico"></span>
                            <div className="errorMessage" id="expirydateErrorMessage" style={{width: state.displayerrorMessage.expirydate?.length>11 && '180px'}}>
                              {state.displayerrorMessage.expirydate}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-3 form-group'>
                          <div className='form-label'>CVV</div>
                          <div className={state.displayerrorMessage.cvv ? 'floating-label-input invalid-input': 'floating-label-input'}>
                            <TextField
                              name="cvv"
                              placeholder='xxx'
                              maxLength="4"
                              value={state.TempData.cvv}
                              onKeyUp={(e) => validate.numericCheckForZipCode(e)}
                              onChange={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "cvv",
                                  "CVV"
                                ))
                              }
                              onBlur={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "cvv",
                                  "CVV"
                                ))
                              }
                            />
                            <span className="error-icon icon-info-ico"></span>
                            <div className="errorMessage" id="cvvErrorMessage" style={{width: state.displayerrorMessage.cvv?.length>11 && '180px'}}>
                              {state.displayerrorMessage.cvv}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                {/*  <div className='checkout-section d-none'>
                    <div className='checkout-section-title'>Sales Center Information</div>
                    <div className='checkout-section-content'>
                      <div className='row'>
                        <div className='col-md-6 form-group'>
                          <div className='form-label'>Sensei ID</div>
                          <div className={state.displayerrorMessage.senseiId ? 'floating-label-input invalid-input': 'floating-label-input'}>
                            <TextField
                              name="senseiId"
                              placeholder='e.g. GHJH-9876-JHNM-JKOY'
                              value={state.TempData.senseiId}
                              onChange={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "senseiId",
                                  "SenseiId"
                                ))
                              }
                              onBlur={(e) =>
                                dispatch(actionCreator.onorderTextFiledChangeValue(
                                  e,
                                  "senseiId",
                                  "SenseiId"
                                ))
                              }
                            />
                            <span className="error-icon icon-info-ico"></span>
                            <div className="errorMessage" id="senseiIdErrorMessage">
                              {state.displayerrorMessage.senseiId}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>*/}
                </form>

                <div className={const_var.estimator_QuestionAnswer?.length > 0 ? 'checkout-section' : 'd-none'}>
                  <div className='checkout-section-title'>Just A Few More Questions</div>
                  <div className='checkout-section-content'>
                    <Questions isNameofModule="order" />
                  </div>
                </div>

                <div className='checkout-section'>
                  <div className='checkout-section-title'>We Are Secured Through -</div>
                  <div className='checkout-section-content secured-content'>
                    {
                      images.map((item, index) => 
                        <div key={index} className='secured-image-item'>
                          <img src={process.env.REACT_APP_BASE_URL+item} alt='secured img'/>
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>

              <div className='checkout-right-container'>
                <div className='building-info-section'>
                  {savingPrice !== 0 ? 
                    <div className='building-info-header'>
                      <i className='icon-discount-ico'></i>
                      <div>
                        <div className='d-flex'>
                          <span className='building-discount-title'>Your savings on this building -&nbsp;</span>
                          <h3>
                            {/* ${(savingPrice).toFixed(2)} */}
                            <CurrencyFormat
                              fixedDecimalScale="2"
                              decimalSeparator="."
                              decimalScale="2"
                              value={(savingPrice).toFixed(2)}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"$"}
                            />
                          </h3>
                        </div>
                        <span>& Free Delivery & Installation</span>
                      </div>
                    </div>
                  :null}

                  <div className='building-info'>
                    <div className='building-image'>
                      <img src={state.blobImg} alt='building img'/>
                    </div>
                    <div className='building-type'>
                      {state.order_data != undefined ? state.order_data.building_name : ""}&nbsp;
                      {state.order_data != undefined
                        ? state.order_data.width
                        : 0}
                      x
                      {state.order_data != undefined
                        ? state.order_data.length
                        : 0}
                      x
                      {state.order_data != undefined
                        ? state.order_data.height
                        : 0}
                      '{" "}
                      {state.order_data != undefined
                        ? state.order_data.roof_style_name
                        : "Vertical"}{" "}
                      </div>
                    <div className='amount-section downpayment'>
                      <div className='amount-name'>Down Payment</div>
                      <div className='amount-price'>
                        {/* ${const_var.BuildingPriceArrar[ "new_down_payment_total"] != undefined ? (const_var.BuildingPriceArrar["new_down_payment_total"] + const_var.BuildingPriceArrar["custom_down_payment_total"] + const_var.BuildingPriceArrar["grvy_value"]).toFixed(2) : 0} */}
                        <CurrencyFormat
                            fixedDecimalScale="2"
                            decimalSeparator="."
                            decimalScale="2"
                            value={const_var.BuildingPriceArrar[ "new_down_payment_total"] != undefined ? (const_var.BuildingPriceArrar["new_down_payment_total"] + const_var.BuildingPriceArrar["custom_down_payment_total"] + const_var.BuildingPriceArrar["grvy_value"]).toFixed(2) : 0}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"$"}
                          />
                      </div>
                    </div>
                    <div className='amount-section'>
                      <div className='amount-name'>Total Amount</div>
                      <div className='sub-amount-price'>
                        {/* $
                        {(state.order_data != undefined && !isNaN(state.order_data.sub_order_total))
                          ? (state.order_data.sub_order_total).toFixed(2)
                          : 0} */}
                          <CurrencyFormat
                            fixedDecimalScale="2"
                            decimalSeparator="."
                            decimalScale="2"
                            value={(state.order_data != undefined && !isNaN(state.order_data.sub_order_total))
                              ? (state.order_data.sub_order_total).toFixed(2)
                              : 0}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"$"}
                          />
                      </div>
                    </div>
                    <div className='amount-section'>
                      <div className='amount-name'>Due Upon Installation</div>
                      <div className='sub-amount-price'>
                       {/* ${const_var.post_data != undefined ? const_var.post_data.building?.due_upon_installation?.toFixed(2) : 0} */}
                        <CurrencyFormat
                            fixedDecimalScale="2"
                            decimalSeparator="."
                            decimalScale="2"
                            value={const_var.post_data != undefined ? const_var.post_data.building?.due_upon_installation?.toFixed(2) : 0}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"$"}
                          />
                      </div>
                    </div>
                  </div>

                  <div className='building-info-footer'>
                    <div>
                      <Checkbox
                        className="d-inline-flex"
                        ripple="RipplePropF"
                        name="agreeTermsAndConditionCheckbox"
                        value={
                          state.agreeTermsAndConditionCheckbox ==
                          false
                            ? ""
                            : state.agreeTermsAndConditionCheckbox
                        }
                        checked={
                          state.agreeTermsAndConditionCheckbox
                        }
                        onChange={(e) =>
                          dispatch(actionCreator.agreeTermsAndConditionCheckboxChange())
                        }
                        label="I agree to the Terms & Conditions mentioned in the building purchase binding agreement."
                      />
                        <div className="errorMessage" id="agreeTermsAndConditionCheckboxErrorMessage" 
                         style={{"font-size":" 13px",
                          "margin-top": "-18px",
                          "padding": "6px",
                          "margin-bottom": "19px",
                          "color": "red",
                          "padding-left": "22px",}}
                        >
                          {state.displayerrorMessage.agreeTermsAndConditionCheckbox}
                        </div>
                      {/* <div className="errorMessage" id="expirydateErrorMessage">
                        {state.displayerrorMessage
                          .agreeTermsAndConditionCheckbox != undefined &&
                        state.displayerrorMessage
                          .agreeTermsAndConditionCheckbox != ""
                          ? "Terms and conditions " +
                            state.displayerrorMessage
                              .agreeTermsAndConditionCheckbox
                          : ""}
                      </div> */}
                    </div>
                    <div className='btn btn-primary' onClick={() => handleCheckout()}>
                      CHECKOUT 
                      <i className='icon-arrow-double-small'></i>
                      <span className="saving-effect">
                        <span></span>
                        <span></span>
                        <span></span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className='contact-container'>
                  <div ref={nextRef} className='what-next' onClick={() => setShowNext(!showNext)}><i className='icon-info'></i>What's Next</div>
                  {
                    showNext &&
                    <div className='next-tooltip'>
                      <i className='icon-cross-ico' onClick={() => setShowNext(false)}></i>
                      <div className='next-tooltip-title'>What's Next</div>
                      <ul>
                        {
                          next_texts.map((item, index) => 
                            <li key={index}>{item}</li>
                          )
                        }
                      </ul>
                    </div>
                  }
                  <div className='contact-phone-number'>
                    <a href={"tel:" + state.order_data.phone_number}>
                      <i className='icon-phone-ico'></i>{state.order_data.phone_number}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={state.termsAndConditionDialogExtraClassToggle?'': 'd-none'}>
            <TermsAndCondition />
          </div>

        </Modal.Body>
      </Modal>
      {state.orderPDFURL != "" ? ( 
          <ThankYou
            show={showModal}
            handleClose={()=>setShowModal(false)}
            orderPDFURL={state.orderPDFURL}
            invoicePDFURL={state.invoicePDFURL}
            thankYouForSaveLater={false}
            phone_number={state.order_data.phone_number}
            domain_url=""
            informUserFlag={state.informUserFlag}
            informUser={state.informUser}
          />
       ) : null}
      {state.orderPDFURL == "" ? (
        <CommonPromptBox
          show={showModal}
          handleClose={()=>setShowModal(false)}
          message={state.alertUsedMSG}
        />
      ) : null}
    </div>
  )
}

export default CheckOut